import API from 'services/api';

export const restoreService = ({ serviceId }: { serviceId: string }) => {
  return API.put(`api/accommodation/calculations/services/${serviceId}/restore`);
};
